import API_CALL from '../API'

interface CommitData {
  achieved_operations: number[]
  from_basis: string
}

const deleteAllRequest = async (basis: string): Promise<any> => {
  try {
    const response = await API_CALL({
      method: 'POST',
      url: `/commit`,
      data: {
        achieved_operations: [],
        from_basis: basis,
      },
    })
    console.log('OK result:', response)
    return response
  } catch (err) {
    console.error('KO result:', err)
    throw err
  }
}

const commitSingleRequest = async (
  basis: string,
  idRequest: string
): Promise<any> => {
  const achieved_operations = idRequest ? [+idRequest] : []
  try {
    const response = await API_CALL({
      method: 'POST',
      url: `/commit`,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      data: {
        achieved_operations,
        from_basis: basis,
      } as CommitData,
    })
    console.log('OK result:', response)
    return response
  } catch (err) {
    console.error('KO result:', err)
    throw err
  }
}

const commitMultipleRequest = async (
  basis: string,
  idRequests: string[]
): Promise<any> => {
  try {
    const response = await API_CALL({
      method: 'POST',
      url: `/commit`,
      data: {
        achieved_operations: idRequests,
        from_basis: basis,
      },
    })
    console.log('OK result:', response)
    return response
  } catch (err) {
    console.error('KO result:', err)
    throw err
  }
}

// API di debug, non utilizzare per scopi differenti!
const commitMultipleRequestForRecovery = async (
  basis: string,
  idRequests: string[]
): Promise<any> => {
  try {
    const response = await API_CALL({
      method: 'POST',
      url: `/commit`,
      params: { test_recovery: true },
      data: {
        achieved_operations: +idRequests,
        from_basis: basis,
      },
    })
    console.log('OK result:', response)
    return response
  } catch (err) {
    console.error('KO result:', err)
    throw err
  }
}

export const CommitService = {
  deleteAllRequest,
  commitSingleRequest,
  commitMultipleRequest,
  commitMultipleRequestForRecovery,
}
